import { useApiQuery } from "@/api/hooks";
import { getAccount } from "@/entities/Finance/Finance.queries";
import { ACCOUNT_LIST } from "@/features/Labeling/constants/labeling.constants";
import clsx from "clsx";

export function AccountLabelFetch({ accountId }: { accountId: string }) {
    const { data: account, isLoading } = useApiQuery(getAccount, {
        params: { accountId },
    });

    if (!account && isLoading) {
        return (
            <div
                className={clsx(
                    "h-10 w-full animate-pulse rounded-xl bg-slate-800",
                )}
            />
        );
    }

    if (!account) {
        return null;
    }

    const taxonomy = ACCOUNT_LIST[account.label];
    const color = taxonomy?.color || "#10B981";

    return (
        <>
            <p className="heading-m mb-1 mt-3">Account</p>
            <div
                className={clsx(
                    "text-color body-s",
                    "flex  items-center gap-3 rounded-lg",
                    " bg-transparent",
                )}
            >
                <div
                    className="size-2 shrink-0 rounded-full"
                    style={{ backgroundColor: color }}
                />

                <p className="body-s text-left">
                    {account.name} - {taxonomy?.name || account.label}
                </p>
            </div>
        </>
    );
}
